<div class="container">
  <div class="text-center">
    <h2>{{ 'homepage_vendor_logged.label1_' + parentApp.distribID | translate }}</h2>
  </div>

  <div class="row vendor-action-list justify-content-center text-center">
    <!-- Configurateurs enfants -->
    <div class="children-card" *ngFor="let child of children" (click)="startNewConfiguration(child.distribID)">
      <figure>
        <img
          class="img-fluid"
          [src]="'assets/img/home/vendor-' + child.distribID + '.jpg'"
          [alt]="'homepage_vendor_logged.label1_' + parentApp.distribID | translate" />
        <figcaption>
          <h2 [innerHtml]="'selection_vendor_logged.label_' + child.distribID | translate"></h2>
        </figcaption>
      </figure>
    </div>
  </div>
</div>
